import React from 'react';

import { Flex, Icon } from '~/components/blocks';
import { Text } from '~/components/partials/PatientBlocks';
import { ColorPalette, MonoColor } from '~/styles/theme';
import { Size } from '~/styles/types';

type Props = {
  error: string;
  fontSize?: Size;
  color?: keyof typeof ColorPalette | keyof typeof MonoColor;
};

export const FieldError = React.memo((props: Props) => {
  const { error, fontSize = 'm', color = 'patientRed' } = props;

  return (
    <Flex alignItems="center">
      <Icon size="l" icon="alert" color="patientRed" />
      <Text whiteSpace="break-spaces" color={color} size={fontSize}>
        {error}
      </Text>
    </Flex>
  );
});

FieldError.displayName = 'FieldError';
